import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";

import { environment } from "@environment";

import { StorageService } from "../services/util/storage.service";
import { UtilityService } from "../services/util/utility.service";

const API_VERSION = "v2";
const API_BASE_PATH = "/customer_address";
const API_URL = `${environment.apiUrl}/${API_VERSION}${API_BASE_PATH}`;

@Injectable({
    providedIn: "root"
})

export class AddressApiService {
    constructor(
        private http: HttpClient,
        private utilityService: UtilityService,
        private storageService: StorageService
    ) {}

    fetch(): Observable<any> {
        const headers = this.getAuthHeaders();
        const outletId = this.storageService.get("outlet_id");
        const params = outletId ? new HttpParams().set("outlet_id", outletId) : {};

        return this.http.get(API_URL, { params, headers });
    }

    create(
		address_type: number,
		address_line_hash: any,
		address_form_name: string,
		locality: string,
		address_custom_name: string,
		polygon_id?: string
	): Observable<any> {
        
		const outlet_id = this.storageService.get("outlet_id");
        const headers = this.getAuthHeaders();

        const body = {
            locality,
            outlet_id,
            address_type,            
            accurate: false,
            address_form_name,
            address_line_hash,
            address_custom_name,
			polygon_id
        };

        return this.http.post(API_URL, body, { headers });
    }

    update(address_type: number,
		address_line_hash: any,
		address_form_name: string,
		address_custom_name: string,
		address_id: number,
		locality: string,
		landmark: string,
		polygon_id?: string
	): Observable<any> {
        
		const headers = this.getAuthHeaders();
        const params = new HttpParams().set("id", address_id);

        const body = {
            locality,
            landmark,
            address_type,
            accurate: false,
            address_form_name,
            address_line_hash,
            address_custom_name,
			polygon_id
        };

        return this.http.put(API_URL, body, { params, headers });
    }

    delete(address_id: number): Observable<any> {
        const headers = this.getAuthHeaders();
        const params = new HttpParams().set("id", address_id);

        return this.http.delete(API_URL, { params, headers });
    }

    private getAuthHeaders(): HttpHeaders {
        const headers = new HttpHeaders({
            "Accept": "application/vnd.phpl.v2",
            ...this.utilityService.getAuthHeaders()
        });

        return headers;
    }
}

